import { Grid, TextField, Typography } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";
import { useForm } from "react-hook-form";
import { AnswersProps } from "../../app/models/Answers";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  reflections: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  feedback: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  explain: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});
const FamilyQuestionnaire: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const { user } = useAppSelector((state) => state.account);

  const defaultValues = {
    reflections: answersData.find((answer) => answer.systemCodeId === 187)
      ?.answer,
    feedback: answersData.find((answer) => answer.systemCodeId === 188)?.answer,
    explain: answersData.find((answer) => answer.systemCodeId === 189)?.answer,
  };

  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  return (
    <Grid container p={2} m={1}>
      <Grid item container spacing={2}>
        <Grid item xs={12}>
          <Typography fontWeight={700} mb={3}>
            CS IV-c - Family Questionnaires Reflection
          </Typography>
          <Typography>
            {user?.credentialTypeId === 4
              ? `Reflect on the feedback you received in the Family Questionnaires you collected. `
              : "How do you make sure you are aware of what's happening in each child's home life? "}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography mb={2}>
            What confirmed your own reflections about yourself?{" "}
          </Typography>
          <TextField
            label="My own reflections about myself were confirmed by"
            fullWidth
            multiline
            rows={2}
            {...register("reflections")}
            name="reflections"
            value={
              answersData.find((answer) => answer.systemCodeId === 187)
                ?.answer || ""
            }
            onChange={(e) => {
              const newValue = e.target.value;
              const systemCodeId = 187;

              newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
            }}
            error={!!errors.reflections?.message}
            helperText={errors.reflections?.message}
          />
          <Typography fontSize={13}>
            {defaultValues.reflections?.length}/500
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography mb={2}>
            What feedback suggested a new goal for professional growth?
          </Typography>
          <TextField
            label="A new goal for professional growth was suggested by"
            fullWidth
            multiline
            rows={2}
            {...register("feedback")}
            name="feedback"
            value={
              answersData.find((answer) => answer.systemCodeId === 188)
                ?.answer || ""
            }
            onChange={(e) => {
              const newValue = e.target.value;
              const systemCodeId = 188;

              newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
            }}
            error={!!errors.feedback?.message}
            helperText={errors.feedback?.message}
          />
          <Typography fontSize={13}>
            {defaultValues.feedback?.length}/500
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography mb={2}>
            Explain how the responses surprised you.
          </Typography>
          <TextField
            label="I was surprised by"
            fullWidth
            multiline
            rows={2}
            {...register("explain")}
            name="explain"
            value={
              answersData.find((answer) => answer.systemCodeId === 189)
                ?.answer || ""
            }
            onChange={(e) => {
              const newValue = e.target.value;
              const systemCodeId = 189;

              newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
            }}
            error={!!errors.explain?.message}
            helperText={errors.explain?.message}
          />
          <Typography fontSize={13}>
            {defaultValues.explain?.length}/500
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default FamilyQuestionnaire;
